"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zDecodePlateRequest = exports.zDecodeVinRequest = exports.zRecordOdometerReading = exports.zListVehiclesQuery = exports.zUpdateVehicleRequest = exports.zCreateVehicleRequest = exports.zOdometerReadingSource = exports.ODOMETER_READING_SOURCES = exports.zVehicleEntryMethod = exports.VEHICLE_ENTRY_METHODS = void 0;
const zod_1 = require("zod");
const query_params_js_1 = require("./query-params.js");
exports.VEHICLE_ENTRY_METHODS = ["vin_lookup", "ymm_select", "manual"];
exports.zVehicleEntryMethod = zod_1.z.enum(exports.VEHICLE_ENTRY_METHODS);
exports.ODOMETER_READING_SOURCES = ["work_order_in", "work_order_out", "manual"];
exports.zOdometerReadingSource = zod_1.z.enum(exports.ODOMETER_READING_SOURCES);
// Every field below is free text or a nullable number — never an FK into
// the reference catalog. The catalog only supplies DEFAULTS for a picker;
// the shop must always be able to override or enter an unlisted vehicle.
// See docs/IMPLEMENTATION_PLAN.md, "The trim problem".
const vehicleFields = {
    modelYear: zod_1.z.number().int().min(1900).max(2100).nullable().optional(),
    make: zod_1.z.string().trim().min(1).nullable().optional(),
    model: zod_1.z.string().trim().min(1).nullable().optional(),
    trim: zod_1.z.string().trim().min(1).nullable().optional(),
    engineDescription: zod_1.z.string().trim().min(1).nullable().optional(),
    vin: zod_1.z.string().trim().min(1).nullable().optional(),
    // Explicit, user-editable — NOT derived from a fixed VIN offset. Prints
    // as "VIN (x)". See db/schema/vehicles.ts.
    vinDisplayCode: zod_1.z.string().trim().min(1).nullable().optional(),
    licensePlate: zod_1.z.string().trim().min(1).nullable().optional(),
    // Only ever populated by a successful plate decode — see the doc comment
    // on this column in apps/api/src/db/schema/vehicles.ts.
    licensePlateState: zod_1.z.string().trim().length(2).nullable().optional(),
    imageUrl: zod_1.z.string().trim().url("Must be a valid URL").nullable().optional(),
    unitNumber: zod_1.z.string().trim().min(1).nullable().optional(),
    refNumber: zod_1.z.string().trim().min(1).nullable().optional(),
    hatNumber: zod_1.z.string().trim().min(1).nullable().optional(),
    lastOdometer: zod_1.z.number().int().min(0).nullable().optional(),
    notes: zod_1.z.string().trim().min(1).nullable().optional(),
};
exports.zCreateVehicleRequest = zod_1.z.object({
    customerId: zod_1.z.number().int().positive(),
    entryMethod: exports.zVehicleEntryMethod.default("manual"),
    ...vehicleFields,
});
exports.zUpdateVehicleRequest = zod_1.z.object({ entryMethod: exports.zVehicleEntryMethod, ...vehicleFields }).partial();
exports.zListVehiclesQuery = zod_1.z.object({
    customerId: zod_1.z.coerce.number().int().positive().optional(),
    // Matches VIN (trgm), license plate, or make/model — see VehiclesService.list().
    search: zod_1.z.string().trim().min(1).optional(),
    includeInactive: query_params_js_1.zBooleanQueryParam.default(false),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(25),
    offset: zod_1.z.coerce.number().int().min(0).default(0),
});
exports.zRecordOdometerReading = zod_1.z.object({
    reading: zod_1.z.number().int().min(0),
    recordedOn: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD"),
    source: exports.zOdometerReadingSource.default("manual"),
});
exports.zDecodeVinRequest = zod_1.z.object({
    vin: zod_1.z.string().trim().min(1),
    modelYear: zod_1.z.number().int().min(1900).max(2100).optional(),
});
exports.zDecodePlateRequest = zod_1.z.object({
    plate: zod_1.z.string().trim().min(1),
    state: zod_1.z.string().trim().length(2),
});
//# sourceMappingURL=vehicles.js.map